// eslint-disable-next-line max-classes-per-file
import { getVersion } from '../../components/util/all';

export enum TourImageActionType {
  None = 'none',
  Text = 'text',
  Image = 'image',
  Music = 'music',
  Video = 'video',
  Iframe = 'iframe',
  Tab = 'tab',
  Panorama = 'panorama',
  Menu = 'menu',
  Treedis = 'treedis',
  ExperiencePopUp = 'experiencePopUp',
}

export enum TourVSImageRotation {
  Vertical = 'vertical',
  Horizontal = 'horizontal',
}

export enum TourImageAction {
  Click = 'click',
  Hover = 'hover',
}

export enum LoadingState {
  Idle = 'Idle',
  Loaded = 'Loaded',
  Loading = 'Loading',
  Error = 'Error',
}

export enum TourImageActionRes {
  Percentage = 'percentage',
  Pixels = 'pixels',
}

export enum VSInteractionType {
  /** CLICK events */
  CLICK = 'INTERACTION.CLICK',
  /** HOVER events */
  HOVER = 'INTERACTION.HOVER',
  /** DRAG events (mousedown then move) */
  DRAG = 'INTERACTION.DRAG',
  DRAG_BEGIN = 'INTERACTION.DRAG_BEGIN',
  DRAG_END = 'INTERACTION.DRAG_END',
  POINTER_MOVE = 'INTERACTION.POINTER_MOVE',
  POINTER_BUTTON = 'INTERACTION.POINTER_BUTTON',
  SCROLL = 'INTERACTION.SCROLL',
  KEY = 'INTERACTION.KEY',
  LONG_PRESS_START = 'INTERACTION.LONG_PRESS_START',
  LONG_PRESS_END = 'INTERACTION.LONG_PRESS_END',
  MULTI_SWIPE = 'INTERACTION.MULTI_SWIPE',
  MULTI_SWIPE_END = 'INTERACTION.MULTI_SWIPE_END',
  PINCH = 'INTERACTION.PINCH',
  PINCH_END = 'INTERACTION.PINCH_END',
  ROTATE = 'INTERACTION.ROTATE',
  ROTATE_END = 'INTERACTION.ROTATE_END',
}

export class VSObject {
  id?: number;

  title: string;

  url: string;

  materialUrl: string;

  fileName?: string;

  scaleX: number;

  scaleY: number;

  scaleZ: number;

  rotationX: number;

  rotationY: number;

  rotationZ: number;

  tourId: number;

  image?: string;

  category?: string;

  copyright?: string;

  isDefault: boolean;

  updatedAt?: string;

  isGLTF: boolean;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.title = model.title || null;
    this.url = model.url || null;
    this.materialUrl = model.materialUrl || null;
    this.fileName = model.fileName || null;
    this.scaleX = model.scaleX || 0.01;
    this.scaleY = model.scaleY || 0.01;
    this.scaleZ = model.scaleZ || 0.01;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.tourId = model.tourId || null;
    this.image = model.image || null;
    this.category = model.category || null;
    this.copyright = model.copyright || null;
    this.isDefault = model.isDefault || false;
    this.updatedAt = model.updatedAt || null;
    this.isGLTF = model.isGLTF || false;
  }
}

export class TourObject {
  id?: number;

  vsObjectId?: number;

  uuid?: string;

  scaleX: number;

  scaleY: number;

  scaleZ: number;

  positionX: number;

  positionY: number;

  positionZ: number;

  rotationX?: number;

  rotationY?: number;

  rotationZ?: number;

  details: VSObject;

  updatedAt?: string;

  active: boolean;

  enableHoverAnimation: boolean;

  hideOnAnimationFinished: boolean;

  floor?: number | null;

  srX: number;

  srY: number;

  srZ: number;

  sweepUuid: string;

  node: any;

  loop: boolean;

  animated: boolean;

  toursVSImages: TourImage[];

  renderRange: number | null;

  startAnimationDistance: number | null;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.vsObjectId = model.vsObjectId || null;
    this.uuid = model.uuid || null;
    this.scaleX = model.scaleX || 0.01;
    this.scaleY = model.scaleY || 0.01;
    this.scaleZ = model.scaleZ || 0.01;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.details = Object.assign(model.vsObject || ({} as VSObject));
    this.updatedAt = model.updatedAt || null;
    this.active = typeof model.active === 'boolean' ? model.active : true;
    this.enableHoverAnimation = typeof model.enableHoverAnimation === 'boolean' ? model.enableHoverAnimation : false;
    this.hideOnAnimationFinished = typeof model.hideOnAnimationFinished === 'boolean' ? model.hideOnAnimationFinished : false;
    this.floor = typeof model.floor === 'number' ? model.floor : null;
    this.srX = model.srX || 0;
    this.srY = model.srY || 0;
    this.srZ = model.srZ || 0;
    this.sweepUuid = model.sweep_uuid || null;
    this.animated = model.animated;
    this.loop = model.loop || false;
    this.toursVSImages = model.toursVSImages;
    this.renderRange = model.renderRange ?? null;
    this.startAnimationDistance = model.startAnimationDistance ?? null;
  }
}

export class VSImage {
  id?: number;

  title: string;

  url: string;

  scaleX: number;

  scaleY: number;

  scaleZ: number;

  rotationX: number;

  rotationY: number;

  rotationZ: number;

  tourId: number;

  isDefault: boolean;

  image?: string;

  updatedAt?: string;

  isVSImage: boolean;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.title = model.title || null;
    this.url = model.url || null;
    this.scaleX = model.scaleX || 0.1;
    this.scaleY = model.scaleY || 0.1;
    this.scaleZ = 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.tourId = model.tourId || null;
    this.image = model.image || null;
    this.updatedAt = model.updatedAt || null;
    this.isDefault = false;
    this.isVSImage = true;
  }

  public getURL() {
    let url = `${process.env.REACT_APP_AWS}${this.url}${getVersion(new Date())}`;
    if (this.url.includes('http')) {
      url = this.url;
    }
    return url;
  }
}

export class TourImage {
  id?: number;

  vsImageId?: number;

  toursVSObjectId?: number;

  uuid?: string;

  width?: number;

  height?: number;

  scaleX: number;

  scaleY: number;

  scaleZ: number;

  positionX: number;

  positionY: number;

  positionZ: number;

  rotationX?: number;

  rotationY?: number;

  rotationZ?: number;

  details: VSImage;

  updatedAt?: string;

  isVSImage: boolean;

  active: boolean;

  enableAnimation: boolean;

  enableHoverAnimation: boolean;

  animationPulse: boolean;

  animationUpDown: boolean;

  animationFlip: boolean;

  effectOpacity: boolean;

  effectStopAnimation: boolean;

  effectHide: boolean;

  // actions
  actionURL: string;

  actionType: TourImageActionType;

  action: TourImageAction;

  text: string;

  popupTitle: string;

  actionRes: TourImageActionRes;

  actionWidth: number;

  actionHeight: number;

  actionResMobile: TourImageActionRes;

  actionWidthMobile: number;

  actionHeightMobile: number;

  panoramaId: number;

  menuId: number;

  subMenuId: number;

  subSubMenuId: number;

  floor?: number | null;

  srX: number;

  srY: number;

  srZ: number;

  sweepUuid: string;

  rotation?: TourVSImageRotation;

  backgroundColor?: string;

  backgroundOpacity?: number;

  textColor?: string;

  buttonColor?: string;

  node: any;

  renderRange: number | null;

  startAnimationDistance: number | null;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.vsImageId = model.vsImageId || null;
    this.toursVSObjectId = model.toursVSObjectId || null;
    this.uuid = model.uuid || null;
    this.width = model.width;
    this.height = model.height;
    this.scaleX = model.scaleX || 0.1;
    this.scaleY = model.scaleY || 0.1;
    this.scaleZ = 0;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.details = Object.assign(model.vsImage || ({} as VSImage));
    this.updatedAt = model.updatedAt || null;
    this.isVSImage = true;
    this.active = typeof model.active === 'boolean' ? model.active : true;
    this.enableAnimation = typeof model.enableAnimation === 'boolean' ? model.enableAnimation : false;
    this.enableHoverAnimation = typeof model.enableHoverAnimation === 'boolean' ? model.enableHoverAnimation : false;
    this.animationPulse = typeof model.animationPulse === 'boolean' ? model.animationPulse : false;
    this.animationUpDown = typeof model.animationUpDown === 'boolean' ? model.animationUpDown : false;
    this.animationFlip = typeof model.animationFlip === 'boolean' ? model.animationFlip : false;
    this.effectOpacity = typeof model.effectOpacity === 'boolean' ? model.effectOpacity : false;
    this.effectStopAnimation = typeof model.effectStopAnimation === 'boolean' ? model.effectStopAnimation : false;
    this.effectHide = typeof model.effectHide === 'boolean' ? model.effectHide : false;
    this.renderRange = model.renderRange ?? null;
    this.startAnimationDistance = model.startAnimationDistance ?? null;

    // actions
    this.actionType = model.actionType || TourImageActionType.None;
    this.action = model.action || TourImageAction.Click;
    this.actionURL = model.actionURL || null;
    this.text = model.text || null;
    this.popupTitle = model.popupTitle || null;
    this.actionRes = model.actionRes || TourImageActionRes.Percentage;
    this.actionWidth = model.actionWidth || 80;
    this.actionHeight = model.actionHeight || 60;
    this.actionResMobile = model.actionResMobile || TourImageActionRes.Percentage;
    this.actionWidthMobile = model.actionWidthMobile || 82;
    this.actionHeightMobile = model.actionHeightMobile || 47;
    this.panoramaId = model.panoramaId || null;
    this.menuId = model.menuId || null;
    this.subMenuId = model.subMenuId || null;
    this.subSubMenuId = model.subSubMenuId || null;
    this.floor = typeof model.floor === 'number' ? model.floor : null;
    this.sweepUuid = model.sweep_uuid || null;
    this.srX = model.srX || 0;
    this.srY = model.srY || 0;
    this.srZ = model.srZ || 0;
    this.rotation = model.rotation || TourVSImageRotation.Vertical;
    this.backgroundColor = model.backgroundColor || '#000000';
    this.backgroundOpacity = model.backgroundOpacity || 0.7;
    this.textColor = model.textColor || '#ffffff';
    this.buttonColor = model.buttonColor || '#ffffff';
  }

  public getURL() {
    let url = `${process.env.REACT_APP_AWS}${this.details.url}${getVersion(new Date())}`;
    // if (this.isVSImage && this.actionType === TourImageActionType.ExperiencePopUp) {
    //   return '/play_experience.svg';
    // }
    if (this.details.url.includes('http')) {
      url = this.details.url;
    }
    return url;
  }
}

export class VSHtml {
  id?: number;

  title: string;

  url: string;

  scaleX: number;

  scaleY: number;

  scaleZ: number;

  rotationX: number;

  rotationY: number;

  rotationZ: number;

  tourId: number;

  image?: string;

  updatedAt?: string;

  isVSHtml: boolean;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.title = model.title || null;
    this.url = model.url || null;
    this.scaleX = model.scaleX || 0.1;
    this.scaleY = model.scaleY || 0.1;
    this.scaleZ = model.scaleZ || 0.1;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.tourId = model.tourId || null;
    this.image = model.image || null;
    this.updatedAt = model.updatedAt || null;
    this.isVSHtml = true;
  }
}

export class TourVSHtml {
  id?: number;

  vsHtmlId?: number;

  tourId?: number;

  active: boolean;

  uuid?: string;

  scaleX: number;

  scaleY: number;

  scaleZ: number;

  positionX: number;

  positionY: number;

  positionZ: number;

  rotationX?: number;

  rotationY?: number;

  rotationZ?: number;

  details: VSHtml;

  updatedAt?: string;

  floor?: number | null;

  srX: number;

  srY: number;

  srZ: number;

  isVSHtml: boolean;

  sweepUuid: string;

  node: any;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.vsHtmlId = model.vsHtmlId || null;
    this.uuid = model.uuid || null;
    this.scaleX = model.scaleX || 0.1;
    this.scaleY = model.scaleY || 0.1;
    this.scaleZ = model.scaleZ || 0.1;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.details = Object.assign(model.vsHtml || ({} as VSHtml));
    this.updatedAt = model.updatedAt || null;
    this.isVSHtml = true;
    this.active = true;
    this.floor = typeof model.floor === 'number' ? model.floor : null;
    this.sweepUuid = model.sweep_uuid || null;
    this.srX = model.srX || 0;
    this.srY = model.srY || 0;
    this.srZ = model.srZ || 0;
    this.node = model.node;
  }
}

export enum VSVideoType {
  Local = 'local',
  Vimeo = 'vimeo',
}

export class VSVideo {
  id?: number;

  title: string;

  url: string;

  type: VSVideoType;

  tourId: number | null;

  width: number;

  height: number;

  scaleX: number;

  scaleY: number;

  scaleZ: number;

  rotationX: number;

  rotationY: number;

  rotationZ: number;

  greenScreenEnabled: boolean;

  greenScreenColor?: string;

  isDefault: boolean;

  image?: string | null;

  updatedAt?: string | null;

  isVSImage: boolean;

  isVSVideo: boolean;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.title = model.title || '';
    this.url = model.url || '';
    this.type = model.type || VSVideoType.Local;
    this.width = model.width || 2;
    this.height = model.height || 2;
    this.scaleX = model.scaleX || 1;
    this.scaleY = model.scaleY || 1;
    this.scaleZ = model.scaleZ || 1;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.tourId = model.tourId || null;
    this.image = model.image || null;
    this.greenScreenEnabled = typeof model.greenScreenEnabled === 'boolean' ? model.greenScreenEnabled : false;
    this.greenScreenColor = model.greenScreenColor;
    this.updatedAt = model.updatedAt || null;
    this.isDefault = false;
    this.isVSImage = false;
    this.isVSVideo = true;
  }

  public getVideoURL(): string {
    if (!this.url) return '';
    let url = `${process.env.REACT_APP_AWS}${this.url}${getVersion(new Date())}`;
    if (this.url.includes('http')) {
      url = this.url;
    }
    return url;
  }

  public getURL(): string {
    if (!this.image) return '';
    let image = `${process.env.REACT_APP_AWS}${this.image}${getVersion(new Date())}`;
    if (this.image.includes('http')) {
      image = this.image;
    }
    return image;
  }
}

export class TourVideo {
  id?: number | null;

  vsVideoId?: number | null;

  uuid?: string | null;

  tourId: number | null;

  scaleX: number;

  scaleY: number;

  scaleZ: number;

  positionX: number;

  positionY: number;

  positionZ: number;

  rotationX?: number;

  rotationY?: number;

  rotationZ?: number;

  details: VSVideo;

  updatedAt?: string | null;

  isVSImage: boolean;

  isVSVideo: boolean;

  active: boolean;

  enableHoverAnimation: boolean;

  animationPulse: boolean;

  animationUpDown: boolean;

  animationFlip: boolean;

  effectOpacity: boolean;

  effectStopAnimation: boolean;

  effectHide: boolean;

  // eslint-disable-next-line camelcase
  sweep_uuid: string | null;

  sweepUuid: string | null;

  srX: number;

  srY: number;

  srZ: number;

  autoplay: boolean;

  loop: boolean;

  floor?: number | null;

  node: any;

  renderRange: number | null;

  startAnimationDistance: number | null;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.vsVideoId = model.vsVideoId || null;
    this.uuid = model.uuid || null;
    this.tourId = model.tourId || null;
    this.scaleX = model.scaleX || 1;
    this.scaleY = model.scaleY || 1;
    this.scaleZ = model.scaleZ || 1;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.details = Object.assign(model.vsVideo || model.details || (new VSVideo() as VSVideo));
    this.updatedAt = model.updatedAt || null;
    this.isVSImage = false;
    this.isVSVideo = true;
    this.enableHoverAnimation = typeof model.enableHoverAnimation === 'boolean' ? model.enableHoverAnimation : false;
    this.animationPulse = typeof model.animationPulse === 'boolean' ? model.animationPulse : false;
    this.animationUpDown = typeof model.animationUpDown === 'boolean' ? model.animationUpDown : false;
    this.animationFlip = typeof model.animationFlip === 'boolean' ? model.animationFlip : false;
    this.effectOpacity = typeof model.effectOpacity === 'boolean' ? model.effectOpacity : false;
    this.effectStopAnimation = typeof model.effectStopAnimation === 'boolean' ? model.effectStopAnimation : false;
    this.effectHide = typeof model.effectHide === 'boolean' ? model.effectHide : false;
    this.active = typeof model.active === 'boolean' ? model.active : true;
    this.sweep_uuid = model.sweep_uuid || null;
    this.sweepUuid = model.sweep_uuid || null;
    this.srX = model.srX || 0;
    this.srY = model.srY || 0;
    this.srZ = model.srZ || 0;
    this.floor = typeof model.floor === 'number' ? model.floor : null;
    this.autoplay = typeof model.autoplay === 'boolean' ? model.autoplay : true;
    this.loop = typeof model.loop === 'boolean' ? model.loop : true;
    this.renderRange = model.renderRange ?? null;
    this.startAnimationDistance = model.startAnimationDistance ?? null;
  }

  public getVideoURL() {
    if (!this.details || !this.details.url) return '';
    let url = `${process.env.REACT_APP_AWS}${this.details.url}${getVersion(new Date())}`;
    if (this.details.url.includes('http')) {
      url = this.details.url;
    }
    return url;
  }

  public getURL(): string {
    if (!this.details || !this.details.image) return '';
    let image = `${process.env.REACT_APP_AWS}${this.details.image}${getVersion(new Date())}`;
    if (this.details.image.includes('http')) {
      image = this.details.image;
    }
    return image;
  }
}

export type VSMedia = VSImage | VSVideo;
export type VSAsset = VSObject | VSMedia;
export type VSTourMedia = TourImage | TourVideo;
export type VSTourAsset = TourObject | VSTourMedia;
